import type * as React from 'react';
import { getPaginated } from '@Domain/Api';
import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';
import subjectDirectoryFetched, {
	type SubjectDirectoryFetchedAction,
} from '@Application/Subjects/SubjectDirectory/Actions/subjectDirectoryFetched';
import subjectDirectoryFetchFailed, {
	type SubjectDirectoryFetchFailedAction,
} from '@Application/Subjects/SubjectDirectory/Actions/subjectDirectoryFetchFailed';
import type FetchSubjectDirectory from '@Application/Subjects/SubjectDirectory/Queries/FetchSubjectDirectory';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = SubjectDirectoryFetchedAction | SubjectDirectoryFetchFailedAction;

// `getPaginated` wants a mutable `results` array; the action widens it to a readonly one.
type PaginatedSubjectDirectory = {
	totalRecords: number;
	results: SubjectPayload[];
};

// No `active` filter is sent: the directory must name a dossier from a past run even once archived.
export default (query: FetchSubjectDirectory) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = new URL(`${parameters.api.host}/api/accounts/${query.accountId}/subjects`);
			url.searchParams.append('facilityIds', String(query.facilityId));

			const payload = await getPaginated<PaginatedSubjectDirectory>(url.toString(), {
				page: 0,
				rowsPerPage: 200,
			});

			const action = subjectDirectoryFetched(payload, query.facilityId);
			dispatch(action);

			return action;
		} catch (error) {
			const action = subjectDirectoryFetchFailed(extractMessages(error));
			dispatch(action);

			return Promise.reject(action);
		}
	};
};
